import { theme } from '@noths/polaris-client-ribbons-base';
import { inset } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var container = /*#__PURE__*/css(["padding:", ";"], inset(spacing.lg));